"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIActionsToast = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
function UIActionsToast({ type, text }) {
    const uiActions = (0, catalog_core_1.useUIActions)();
    return react_1.default.createElement(UIActionsToastInternal, { type: type, text: text, uiActions: uiActions });
}
exports.UIActionsToast = UIActionsToast;
class UIActionsToastInternal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.toastId = null;
    }
    componentDidMount() {
        this.popToast();
    }
    componentDidUpdate(prevProps) {
        if (this.props.type !== prevProps.type || this.props.text !== prevProps.text
            || this.props.uiActions !== prevProps.uiActions) {
            this.popToast();
        }
    }
    componentWillUnmount() {
        this.closeToastIfOpen();
    }
    render() {
        return null;
    }
    popToast() {
        this.closeToastIfOpen();
        this.toastId = this.props.uiActions.popToast(this.props.type, this.props.text);
    }
    closeToastIfOpen() {
        if (this.toastId != null) {
            this.props.uiActions.closeToast(this.toastId);
            this.toastId = null;
        }
    }
}
//# sourceMappingURL=UIActionsToast.js.map